const students = {
  // Page meta
  pageTitle: 'الطلاب',
  pageSubtitle: 'إدارة تسجيل الطلاب وسجلاتهم',
  totalEnrolled: 'إجمالي <strong>{{count}}</strong> طالب مسجل عبر جميع الأقسام',
  myStudentsTitle: 'طلابي',
  myStudentsSubtitle: 'عرض وإدارة الطلاب في فصلك',
  teacherTotalEnrolled: '<strong>{{count}}</strong> طلاب مسجلين في فصلك',
  // Table columns
  studentId: 'معرف الطالب',
  name: 'الاسم',
  class: 'الفصل',
  className: 'الفصل / القسم',
  teacherName: 'اسم المعلم',
  classTeacher: 'معلم الفصل',
  dob: 'تاريخ الميلاد',
  fatherName: 'اسم الأب',
  motherName: 'اسم الأم',
  contactFather: 'اتصال (الأب)',
  contactMother: 'اتصال (الأم)',
  district: 'المنطقة',
  status: 'الحالة',
  call: 'اتصال',
  // Status
  enrolled: 'مسجل',
  pending: 'قيد الانتظار',
  draft: 'مسودة',
  inactive: 'غير نشط',
  // Filters
  searchStudents: 'البحث عن طلاب...',
  allClasses: 'جميع الفصول',
  hideInactive: 'إخفاء غير النشطين',
  showingInactive: 'عرض غير النشطين',
  // Enrollment modal
  step1Label: 'البيانات',
  step2Label: 'تفاصيل الوصي',
  step3Label: 'المستندات',
  studentDemographics: 'بيانات الطالب',
  guardianInformation: 'معلومات الوصي',
  documentUpload: 'رفع المستندات',
  step1Title: 'بيانات الطالب',
  step2Title: 'معلومات الوصي / ولي الأمر',
  step3Title: 'رفع المستندات',
  saveDraft: 'حفظ كمسودة',
  submitEnroll: 'إرسال (تسجيل)',
  enterFullName: 'أدخل الاسم الكامل للطالب',
  fullResidentialAddress: 'العنوان السكني الكامل',
  selectClassSection: 'اختر الفصل / القسم',
  assignedTeacher: 'المعلم المعين',
  noTeacherAssigned: 'لم يتم تعيين معلم',
  selectClassFirst: '— اختر الفصل أولاً —',
  fathersFullName: 'الاسم الكامل للأب',
  mothersFullName: 'الاسم الكامل للأم',
  parentEmail: 'parent@email.com',
  districtName: 'اسم المنطقة',
  townOrCity: 'اسم المدينة أو البلدة',
  documentsDescription: 'قم برفع المستندات المطلوبة. الصيغ المقبولة: PDF, JPG, PNG (بحد أقصى 5 ميجابايت لكل ملف).',
  // Class context banner
  enrolledCount: '{{count}} طالب مسجل',
  enrolledCountPlural: '{{count}} طلاب مسجلين',
  backToFaculty: 'العودة إلى الكادر',
  unassigned: 'غير معين',
  // Edit modal
  editStudent: 'تعديل الطالب',
  saveChanges: 'حفظ التغييرات',
  deactivate: 'تعطيل',
  // Documents section
  documents: 'المستندات',
  uploadedCount: '{{uploaded}} من {{total}} تم رفعها',
  requiredMissing: '({{count}} مطلوبة مفقودة)',
  required: 'مطلوب',
  notUploaded: 'لم يتم الرفع',
  documentPreview: 'معاينة المستند',
  documentPreviewDescription: 'هذه معاينة placeholder لـ <strong>{{fileName}}</strong>. في النسخة النهائية، سيتم عرض المستند الفعلي هنا.',
  pdfDocument: 'مستند PDF',
  verified: 'تم التحقق',
  uploadDocument: 'رفع مستند',
  closePreview: 'إغلاق المعاينة',
  previewDocument: 'معاينة المستند',
  downloadDocument: 'تنزيل المستند',
  // Status labels
  aadhaarNumber: 'رقم Aadhaar',
  udidNumber: 'رقم UDID',
  emailAddress: 'البريد الإلكتروني',
  townLabel: 'المدينة / البلدة',
  // Empty state
  noStudentsFound: 'لم يتم العثور على طلاب مطابقين لمعايير البحث.',
  // Footer
  reactivateStudent: 'إعادة تنشيط الطالب',
  confirmReactivation: 'تأكيد إعادة التنشيط',
  reactivateConfirm: 'إعادة تنشيط {{name}}؟',
  addStudent: 'إضافة طالب',
  // Contact dropdown
  callParent: 'الاتصال بولي الأمر',
  father: 'الأب',
  mother: 'الأم',
  // Alert / Incident
  alert: 'تنبيه',
  incident: 'حادثة',
  incidents: 'حوادث',
  incidentsOnly: 'حوادث ({{count}})',
  showingIncidentsOnly: 'الحوادث فقط',
};

export default students;